import { Dayjs } from 'dayjs'

import { add, subtract } from './addAndSubtract'
import { DATE_TEMPLATES } from './dateTemplates'
import { format } from './format'
import { getToday } from './getToday'
import { isSameDate } from './isSameDate'

/**
 * Function to convert a Dayjs date object into a human-readable string.
 *
 * @param {Dayjs} date - The date to be converted.
 *
 * @returns {string} - The human-readable string representation of the date.
 *
 * If the date is the same as today, it returns "i dag kl. HH:mm".
 * If the date is the same as yesterday, it returns "i går kl. HH:mm".
 * If the date is the same as tomorrow, it returns "i morgen kl. HH:mm".
 * Otherwise, it returns the date in the format "DD.MM.YYYY kl. HH:mm".
 */
export function humanizeDate(date: Dayjs) {
    const today = getToday()

    if (isSameDate(today, date)) {
        return `i dag kl. ${format(date, DATE_TEMPLATES.time)}`
    }

    if (isSameDate(subtract(today, 1, 'day'), date)) {
        return `i går kl. ${format(date, DATE_TEMPLATES.time)}`
    }

    if (isSameDate(add(today, 1, 'day'), date)) {
        return `i morgen kl. ${format(date, DATE_TEMPLATES.time)}`
    }

    return format(date, DATE_TEMPLATES.norwegianDateTime)
}
